// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
// Crawling Loader
export const CRAWL_LOADING = 'CRAWL_LOADING';
// For Unauthorization
export const UNAUTHORIZED_CHAT_AI = "UNAUTHORIZED_CHAT_AI";
//For Crawled Url
export const CRAWLED_URL = "CRAWLED_URL";
//For Url listing
export const URL_LISTING = "URL_LISTING";
// For External Listing Asset chat ai
export const FETCH_EXTERNAL_ASSET_LISTING = "FETCH_EXTERNAL_ASSET_LISTING";
// For Text Listing Asset chat ai
export const TEXT_LISTING = "TEXT_LISTING";
// For Internal Listing Asset chat ai
export const FETCH_INTERNAL_ASSET_LISTING = "FETCH_INTERNAL_ASSET_LISTING";

export const UPDATED_PROMPT_LIST = "UPDATED_PROMPT_LIST";

export const CHAT_LOADING = "CHAT_LOADING";

export const UPLOAD_LOADING = "UPLOAD_LOADING";

export const PAGINATION_COUNT = "PAGINATION_COUNT";

export const API_CALL_HIDER = "API_CALL_HIDER";

export const GREETING_MESSAGE_DATA = "GREETING_MESSAGE_DATA";

export const SET_DROPDOWN_DATA = "SET_DROPDOWN_DATA";

export const ENGAGE_LISTING = "ENGAGE_LISTING"; 

export const FETCH_LEAD_LISTING = "FETCH_LEAD_LISTING"; 

export const EDIT_ENGAGE_DATA = "EDIT_ENGAGE_DATA"; 

export const OPERATION_MODE = "OPERATION_MODE"; 

export const EDIT_ENGAGE_MEETING_DATA = "EDIT_ENGAGE_MEETING_DATA"; 

export const URL_PROCESSING = "URL_PROCESSING"; 
// Chat Design
export const CHAT_DESIGN_DATA = "CHAT_DESIGN_DATA";
 
export const FETCH_GREETING_DATA = "FETCH_GREETING_DATA";

export const CHAT_DESIGN_SCREENSHOT = "CHAT_DESIGN_SCREENSHOT"; 

// Fine Tuning

export const FETCH_CORRECTION_LISTING = "FETCH_CORRECTION_LISTING"; 

export const FETCH_INPUTS_LISTING = "FETCH_INPUTS_LISTING"; 

// OnBoarding
export const ONBOARDING_DATA = "ONBOARDING_DATA"; 

// Token
export const TOKEN_DATA = "TOKEN_DATA"; 
export const T_DATA = "T_DATA"; 














